import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { ErrorOutline, Refresh } from '@mui/icons-material';

interface ErrorFallbackProps {
  error?: string;
  onRetry?: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ 
  error = "University configuration could not be loaded", 
  onRetry 
}) => {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          py: 4,
        }}
      >
        <ErrorOutline sx={{ fontSize: 80, color: 'error.main', mb: 3 }} />
        
        <Typography variant="h4" gutterBottom color="error.main" fontWeight={600}>
          Configuration Error
        </Typography>
        
        <Typography variant="h6" gutterBottom color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
          Failed to load university configuration
        </Typography>
        
        <Paper 
          sx={{ 
            p: 3, 
            mb: 3, 
            backgroundColor: '#f5f5f5', 
            maxWidth: '100%',
            width: '100%',
            maxHeight: '400px',
            overflow: 'auto'
          }}
        >
          <Typography 
            variant="body2" 
            component="pre" 
            sx={{ 
              fontFamily: 'monospace',
              fontSize: '0.875rem',
              lineHeight: 1.5,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word'
            }}
          >
            {error}
          </Typography>
        </Paper>
        
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          {onRetry && (
            <Button
              variant="contained"
              startIcon={<Refresh />}
              onClick={onRetry}
              sx={{ minWidth: 140 }}
            >
              Retry
            </Button>
          )}
          
          <Button
            variant="outlined"
            onClick={() => window.location.reload()}
            sx={{ minWidth: 140 }}
          >
            Reload Page
          </Button>
        </Box>
     
      </Box>
    </Container>
  );
};

export default ErrorFallback;